import styled from 'styled-components'

export const Container = styled.header`
  height: 0;
`
